import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import VueTheMask from 'vue-the-mask'
import Vuelidate from 'vuelidate'
import money from 'v-money'
import * as FullStory from '@fullstory/browser'
import VueGtag from 'vue-gtag'
import getGoogleAnalyticsSettings from './utils/googleAnalytics'
import { sanitizeUrl } from '@braintree/sanitize-url'
import { applyStoneRebrandFavicon } from './utils/stone-rebrand-favicon.utils'
import './plugins/click-outside'

import 'emerald-workbench/dist/emerald.jadestone.min.css'

Vue.use(Vuelidate)
Vue.use(VueTheMask)
Vue.use(VueCookies)
Vue.use(money, { precision: 2 })

Vue.prototype.$sanitize = sanitizeUrl

if (['production'].includes(process.env.VUE_APP_CORE_ENV)) {
  FullStory.init({ orgId: 'BKP05' })
  Vue.prototype.$FullStory = FullStory

  const googleAnalyticsSettings = getGoogleAnalyticsSettings()
  Vue.use(VueGtag, googleAnalyticsSettings, router)
}

async function loadApplication () {
  applyStoneRebrandFavicon()
  new Vue({
    router,
    store,
    i18n,
    money,
    render: h => h(App)
  }).$mount('#app')
}

loadApplication()
